export const SET_ENTITY_SUBMITS_IN_TASKCONTEXT = 'SET_ENTITY_SUBMITS_IN_TASKCONTEXT';
export const UNSET_ENTITY_SUBMITS_IN_TASKCONTEXT = 'UNSET_ENTITY_SUBMITS_IN_TASKCONTEXT';
